<template>
    <div class="afu-tabs afu-overflow-hidden afu-shadow-lg afu-rounded-card afu-bg-white">
        <div class="afu-tabs-header afu-flex afu-justify-between">
            <div
                v-if="title"
                class="afu-text-xs afu-text-black afu-font-semibold afu-px-6 afu-py-5 afu-hidden md:afu-block"
            >
                {{ title }}
            </div>
            <ul class="afu-tabs-list afu-flex afu-list-none afu-m-0 afu-p-0">
                <li
                    v-for="(tab, index) in tabs"
                    :key="index"
                    class="afu-tabs-item afu-flex afu-items-center first:afu-ml-5 md:first:afu-ml-0 afu-mr-5 afu-border-transparent afu-border-b-2 afu-border-solid afu-border-t-0 afu-border-r-0 afu-border-l-0"
                    :class="[{ 'is-active afu-border-primary': tab.isActive }, `afu-item-${tabClass(tab.name)}` ]"
                >
                    <a
                        :href="tab.href"
                        @click="selectTab(tab)"
                        class="afu-tabs-link afu-text-base afu-py-5 hover:afu-text-primary afu-no-underline"
                        :class="[tab.isActive ? 'afu-text-primary' : 'afu-text-neutral-dark']"
                    >
                        {{ tab.name }}
                    </a>
                </li>
            </ul>
        </div>

        <div class="tabs-details afu-border-t afu-border-solid afu-border-b-0 afu-border-r-0 afu-border-l-0 afu-border-neutral">
            <slot />
        </div>
    </div>
</template>

<script>
    export default {
        name: 'C1Tabs',

        props: {
            title: {
                type: String,
                default: '',
            },
        },

        data() {
            return {
                tabs: [],
            };
        },

        created() {
            this.tabs = this.$children;
        },

        methods: {
            selectTab(selectedTab) {
                this.tabs.forEach(tab => {
                    tab.isActive = (tab.name == selectedTab.name);
                });
            },
            tabClass(str) {
                return str.toLowerCase().replace(/\s+/g, '-');
            },
        },
    };
</script>
